"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DELETE_MESSAGE = exports.GET_NUM_UNREAD_MESSAGES = exports.REMOVE_MESSAGE = exports.PUT_MESSAGE = exports.SEND_MESSAGE_CANCEL = exports.SEND_MESSAGE_FAILED = exports.SEND_MESSAGE_SUCCESS = exports.SEND_MESSAGE_REQUEST = exports.FETCH_ATTACHMENTS_CANCEL = exports.FETCH_ATTACHMENTS_FAILED = exports.FETCH_ATTACHMENTS_SUCCESS = exports.FETCH_ATTACHMENTS_REQUEST = exports.MESSAGE_READ_CANCEL = exports.MESSAGE_READ_FAILED = exports.MESSAGE_READ_SUCCESS = exports.MESSAGE_READ_REQUEST = exports.FETCH_MESSAGES_CANCEL = exports.FETCH_MESSAGES_FAIL = exports.FETCH_MESSAGES_SUCCESS = exports.FETCH_MESSAGES_REQUEST = exports.RECEIVE_MESSAGE = void 0;
exports.RECEIVE_MESSAGE = '@message/RECEIVE_MESSAGE';
exports.FETCH_MESSAGES_REQUEST = '@message/FETCH_MESSAGES_REQUEST';
exports.FETCH_MESSAGES_SUCCESS = '@message/FETCH_MESSAGES_SUCCESS';
exports.FETCH_MESSAGES_FAIL = '@message/FETCH_MESSAGES_FAIL';
exports.FETCH_MESSAGES_CANCEL = '@message/FETCH_MESSAGES_CANCEL';
exports.MESSAGE_READ_REQUEST = '@message/MESSAGE_READ_REQUEST';
exports.MESSAGE_READ_SUCCESS = '@message/MESSAGE_READ_SUCCESS';
exports.MESSAGE_READ_FAILED = '@message/MESSAGE_READ_FAILED';
exports.MESSAGE_READ_CANCEL = '@message/MESSAGE_READ_CANCEL';
exports.FETCH_ATTACHMENTS_REQUEST = '@message/FETCH_ATTACHMENTS_REQUEST';
exports.FETCH_ATTACHMENTS_SUCCESS = '@message/FETCH_ATTACHMENTS_SUCCESS';
exports.FETCH_ATTACHMENTS_FAILED = '@message/FETCH_ATTACHMENTS_FAILED';
exports.FETCH_ATTACHMENTS_CANCEL = '@message/FETCH_ATTACHMENTS_CANCEL';
exports.SEND_MESSAGE_REQUEST = '@message/SEND_MESSAGE_REQUEST';
exports.SEND_MESSAGE_SUCCESS = '@message/SEND_MESSAGE_SUCCESS';
exports.SEND_MESSAGE_FAILED = '@message/SEND_MESSAGE_FAILED';
exports.SEND_MESSAGE_CANCEL = '@message/SEND_MESSAGE_CANCEL';
exports.PUT_MESSAGE = '@message/PUT_MESSAGE';
exports.REMOVE_MESSAGE = '@message/REMOVE_MESSAGE';
exports.GET_NUM_UNREAD_MESSAGES = '@message/GET_NUM_UNREAD_MESSAGES';
exports.DELETE_MESSAGE = '@message/DELETE_MESSAGE';